import { CustomBackdrop, useApi, useEffect, useParams, useState } from "../../../utils/globalImports";
import ProjectSummaryComponent from "../../Project/ProjectSummaryComponent";
interface ProposalFeeStageSummaryProps {

}
const ProposalFeeStageSummary: React.FC<ProposalFeeStageSummaryProps> = ({ }) => {
  const { feeStageId } = useParams<{ feeStageId?: string }>();
  const [Data, SetData] = useState<{ description: string, value: number, icon: string, sectionId: number, textvalue: string | null }[]>();
  const { execute, loading } = useApi();
  const fetchData = async () => {
    try {
      const { data } = await execute<any>("get", "/project/commercials", { type: 3, id: feeStageId, feestageId: feeStageId });
      SetData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <ProjectSummaryComponent data={Data || []} heading="FeeStage" subHeading="Overview of fee stage details and values." />
      <CustomBackdrop open={loading} />
    </div>
  );
};

export default ProposalFeeStageSummary;